import { useEffect, useState } from "react";
import { actions, useAppState } from "./context/AppContext";
import { Navigate } from "react-router-dom";
import { auth } from "./services/firebase";

function PrivateRoute({ children }) {
  const { dispatch, state } = useAppState();
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      dispatch(actions.setUser(user));
      setAuthChecked(true);
    });

    dispatch(actions.setRouteProtection(true));
    return () => {
      unsubscribe();
      dispatch(actions.setRouteProtection(false));
    };
  }, [dispatch]);

  if (!authChecked) {
    return <div className="loading-screen regular-2xl">Loading...</div>;
  }

  return state.user ? children : <Navigate to="/" />;
}

export default PrivateRoute;
